if (!customElements.get('sticky-add-cart')) {
  class StickyAddCart extends HTMLElement {
    constructor() {
      super();
      this.handleProductSectionUpdated = this.handleProductSectionUpdated.bind(this);
      this.handleQuantitySync = this.handleQuantitySync.bind(this);
    }

    connectedCallback() {
      this.setupObserver();
      this.bindQuantitySync();
      this.syncInitialQuantity();
      document.addEventListener('product:section:updated', this.handleProductSectionUpdated);
    }

    disconnectedCallback() {
      this.teardownObserver();
      this.unbindQuantitySync();
      document.removeEventListener('product:section:updated', this.handleProductSectionUpdated);
    }

    getSectionId() {
      return this.dataset.mainSectionId;
    }

    getMainQuantityInput() {
      const sectionId = this.getSectionId();
      if (!sectionId) return null;
      return document.getElementById(`Quantity-${sectionId}`);
    }

    getStickyQuantityInput() {
      return this.querySelector('.sticky-add-cart__quantity-input');
    }

    bindQuantitySync() {
      document.addEventListener('change', this.handleQuantitySync, true);
      document.addEventListener('input', this.handleQuantitySync, true);
    }

    unbindQuantitySync() {
      document.removeEventListener('change', this.handleQuantitySync, true);
      document.removeEventListener('input', this.handleQuantitySync, true);
    }

    syncInitialQuantity() {
      const mainInput = this.getMainQuantityInput();
      const stickyInput = this.getStickyQuantityInput();
      if (!mainInput || !stickyInput) return;

      if (mainInput.value !== stickyInput.value) {
        stickyInput.value = mainInput.value;
      }
    }

    syncValue(fromInput, toInput) {
      if (!fromInput || !toInput) return;
      if (toInput.value === fromInput.value) return;
      toInput.value = fromInput.value;
      toInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    handleQuantitySync(event) {
      const target = event.target;
      if (!(target instanceof HTMLInputElement)) return;

      const mainInput = this.getMainQuantityInput();
      const stickyInput = this.getStickyQuantityInput();
      if (!mainInput || !stickyInput) return;

      if (target === stickyInput) {
        this.syncValue(stickyInput, mainInput);
      } else if (target === mainInput) {
        this.syncValue(mainInput, stickyInput);
      }
    }

    setupObserver() {
      this.teardownObserver();
      this.productSectionWrapper = document.querySelector('.product');
      if (!this.productSectionWrapper) return;

      this._observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.classList.toggle('sticky-add-cart--hidden', entry.isIntersecting);
          });
        },
        {
          root: null,
          threshold: 0.1,
        }
      );

      this._observer.observe(this.productSectionWrapper);
    }

    teardownObserver() {
      if (this._observer) this._observer.disconnect();
      this._observer = null;
    }

    async handleProductSectionUpdated(event) {
      const productUrl = event?.detail?.productUrl;
      const sectionId = this.dataset.mainSectionId || event?.detail?.sectionId;

      this.setupObserver();
      this.syncInitialQuantity();

      if (!productUrl || !sectionId) return;

      try {
        const response = await fetch(`${productUrl}${productUrl.includes('?') ? '&' : '?'}section_id=${sectionId}`);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const htmlText = await response.text();
        const html = new DOMParser().parseFromString(htmlText, 'text/html');
        const nextSticky = html.querySelector('sticky-add-cart');
        if (!nextSticky) return;

        this.replaceWith(nextSticky);
      } catch (error) {
        console.error('Sticky add cart update error:', error);
      }
    }
  }

  customElements.define('sticky-add-cart', StickyAddCart);
}
